module.exports = __webpack_public_path__ + "img/444.519ef45.519ef45e.png";